import {
  ISlotsState,
  setSelectedSlotDetails,
  setSlotBookingFilters,
  setUserAddress,
  setCurrentFormServiceId,
  setAhsSubServiceId,
  setAhsSubServiceName,
  setAtHomePreviousFlow,
  setIsAhsRepeatUser,
} from "@/app_redux/reducers/slices/auth/slots_slice";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useRouter } from "@/app/hooks/useRouter";
import { useSearchParams } from "react-router-dom";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useEffect, useMemo, useRef, useState } from "react";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import { useStringConstants } from "@/app/hooks/useStringConstants";
import { ISelectMenuItemData } from "@/app/components/ui/interface";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { IClinicListResponseData } from "@/api_framework/api_modals/Clinics";
import { useOrgCitiesListAPI } from "@/app/hooks/api_hooks/org/useOrgCitiesListAPI";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { useLatestBookingAPI } from "@/app/hooks/api_hooks/bookings/useLatestBookingAPI";
import { useBookingSummaryAPI } from "@/app/hooks/api_hooks/bookings/useBookingSummaryAPI";
import { useStaffClinicListAPI } from "@/app/hooks/api_hooks/clinic/useStaffClinicListAPI";
import { useClinicDetailsAPI } from "@/app/hooks/api_hooks/clinic/useClinicDetailsAPI";
import { useBookedSlotsListAPI } from "@/app/hooks/api_hooks/bookings/useBookedSlotsListAPI";
import { useOrgClinicProvidersAPI } from "@/app/hooks/api_hooks/org/useOrgClinicProvidersAPI";
import { useBookingSlotsListAPI } from "@/app/hooks/api_hooks/bookings/useBookingSlotsListAPI";
import { useOverBookingsListAPI } from "@/app/hooks/api_hooks/bookings/useOverBookingsListAPI";
import { useOrgServicesByFilterAPI } from "@/app/hooks/api_hooks/org/useOrgServicesByFilterAPI";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { IBookingSlotsFilterBody, IBookingSlotsResponseData } from "@/api_framework/api_modals/Bookings";
import {
  buildBookingServiceMaps,
  resolveBookingServiceSelection,
  resolveLegacyDiagnosticSubServiceId,
  toDiagnosticsReplacement,
} from "@/app/utils/bookingServiceSelection";
import { HOME_SERVICE_ID, VC_SERVICE_TYPE_IDS } from "@/constants";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";
import { useUserPersonaDetailsAPI } from "@/app/hooks/api_hooks/customer_profile/useUserPersonaDetailsAPI";
import {
  AHS_BOOKING_LINK_ELIGIBLE_CITIES,
  AHS_REPEAT_PERSONA,
} from "@/app/components/routes/auth_routes/SlotsScreen/constants";
import {
  IBookingFiltersFormFields,
  IGeoClinicDetails,
  ISlotsAddressOption,
} from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/interface";
import {
  buildCityByNormalizedName,
  getCityIdsForPayload as resolveCityIdsForPayload,
  getVisibleCityIdFromFilter,
  isSelectedCityIncludedInFilter,
  mapAddressToGeoOption,
  normalizeCityName,
} from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/helpers";
export const useBookingFilters = () => {
  const [filtersError, setFiltersErrors] = useState<boolean>(false);
  const [showFilters, _setShowFilters] = useState<boolean>(true);
  const userRole = useAppSelector((state) => state.auth.userRole);
  const dispatch = useAppDispatch();
  const { getRouteKey } = useRouter();
  const stringConstants = useStringConstants();
  const { serviceTypes, execute: fetchOrgServicesByFilter } = useOrgServicesByFilterAPI();
  const routeIdCustomerProfile = getRouteKey("CUSTOMER_PROFILE", "id");
  const slotsRouteId = getRouteKey("SLOTS", "id");
  const fetchPWLClinics = useStaffClinicListAPI("SLOTS");
  const fetchOrgCities = useOrgCitiesListAPI("SLOTS");
  const fetchPWLProviders = useOrgClinicProvidersAPI("SLOTS");
  const fetchBookingsSlotsAPI = useBookingSlotsListAPI();
  const fetchBookedSlotsAPI = useBookedSlotsListAPI();
  const fetchOverbookingList = useOverBookingsListAPI();
  const { execute: fetchBookingSummary } = useBookingSummaryAPI();
  const { execute: fetchLatestBooking, latestBooking, isLatestBookingInProgress } = useLatestBookingAPI();
  const { execute: fetchRescheduleClinicDetails, clinicAddess: rescheduleClinicDetails } = useClinicDetailsAPI();
  const { execute: fetchPersonaDetails, personaTags } = useUserPersonaDetailsAPI();
  const { routeState: customerProfileRouteState } = useRouteInfo(routeIdCustomerProfile);
  const { pet_species: petSpeciesItems, serviceList } = useArrayConstants();
  const { routeState: slotsRouteState } = useRouteInfo(slotsRouteId);
  const { filters: slotsFilters, disableSlotsFilter, atHomePreviousFlow, isAhsRepeatUser } =
    slotsRouteState.state as ISlotsState;
  const { petDetails, customerId, petId, customerAddresses } =
    customerProfileRouteState.state as ICustomerProfileState;
  const { routeState } = useRouteInfo(getRouteKey("SLOTS", "id"));
  const { clinics, providers, cities, isPageReadonly, slotsList, address: reduxUserAddress, rescheduledBooking, rescheduleFlag } = routeState.state as ISlotsState;
  const [isPaidbooking, setIsPaidbooking] = useState<boolean>(false);
  const [isPaidPriceAmount, setIsPaidPriceAmount] = useState<number | null>(null);
  const [isSearchSlotButtonClick, setIsSearchSlotButtonClick] = useState(false);
  const [hasShownNudges, setHasShownNudges] = useState(false);
  const [isCheckPricesOpen, setIsCheckPricesOpen] = useState(false);
  const [selectedClinic, setSelectedClinic] = useState<string[] | null>(null);
  const latestBookingFetchKeyRef = useRef<string | null>(null);
  const pendingLatestProviderIdRef = useRef<string | null>(null);
  const rescheduleClinicPrefilledRef = useRef<string | null>(null);
  const rescheduleAutoSearchedRef = useRef<string | null>(null);
  const defaultServiceAppliedRef = useRef(false);
  const [isAddressListModalOpen, setIsAddressListModalOpen] = useState(false);
  const [isAddAddressModalOpen, setIsAddAddressModalOpen] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState<string | null>(null);
  const [slotsAddressList, setSlotsAddressList] = useState<ISlotsAddressOption[]>([]);
  const [openVCLink, setOpenVCLink] = useState<boolean>(false);
  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);
  const { execute: logAPI } = useClickLogAPI();
  const [params, setParams] = useSearchParams();
  const rescheduleBookingId = params?.get("rbi");
  const shouldOpenAddressListFromQuery = params?.get("open_address_list")?.toLowerCase() === "true";

  const formHook = useForm<IBookingFiltersFormFields>({
    mode: "onChange",
    defaultValues: {
      clinics: [],
      providers: [],
      lat: null,
      locationId: null,
      long: null,
      city: "",
      date: format(new Date(Date.now()), stringConstants?.fieldDOBFormat),
      address: null,
      address_data: null,
    },
  });

  useEffect(() => {
    if (slotsList?.length >= 0) {
      const filteredSlots = slotsList
        ?.flatMap((clinic) => clinic.data)
        ?.flatMap((staff) => staff.data)
        ?.filter((slot) => slot.prepaid_booking_slot === "YES");
      if (filteredSlots?.length === 0) {
        setIsPaidbooking(false);
        setIsPaidPriceAmount(null);
      } else {
        setIsPaidbooking(true);
        setIsPaidPriceAmount(filteredSlots?.length > 0 && filteredSlots[0]?.booking_fee);
      }
    }
  }, [slotsList]);

  useEffect(() => {
    if (!shouldOpenAddressListFromQuery) return;
    setIsAddressListModalOpen(true);
    const nextParams = new URLSearchParams(params);
    nextParams.delete("open_address_list");
    setParams(nextParams, { replace: true });
  }, [shouldOpenAddressListFromQuery, params, setParams]);

  const validateConditionalFormFields = (data: IBookingFiltersFormFields) => {
    let isValid = false;
    if (data?.city !== "" || data?.clinics?.length > 0 || data?.providers?.length > 0 || data.locationId !== null) {
      isValid = true;
      setFiltersErrors(false);
    }
    return isValid;
  };

  const slotSearchClickLog = (
    data: IBookingFiltersFormFields,
    slotResponseData: IBookingSlotsResponseData[] | null,
  ) => {
    const selectedServiceName = data?.serviceName || serviceTypeNamesByIdMap[data?.service] || null;
    const selectedSubServiceName =
      data?.subServiceName || subServiceByIdMap[data?.subService]?.sub_service_name || null;
    const selectedCity = cities?.find((city) => city.id === data.city);
    const isAllClinicsSelected = data?.clinics?.includes("-1");
    const selectedClinics = (
      isAllClinicsSelected ? clinics : clinics?.filter((clinic) => data?.clinics?.includes(clinic.id))
    )
      ?.map((clinic) => ({
        id: clinic.id,
        name: clinic.display_name,
      }))
      ?.filter(Boolean);
    const isAllProvidersSelected = data?.providers?.includes("-1");
    const selectedProviders = (
      isAllProvidersSelected ? providers : providers?.filter((provider) => data?.providers?.includes(provider.staff_id))
    )
      ?.map((provider) => ({
        id: provider.staff_id,
        name: provider.name,
      }))
      ?.filter(Boolean);
    const selectedPetTypeId = isPageReadonly ? data.petSpeciesId : petDetails?.pet_species_type_id;
    const selectedPetType = petSpeciesItems?.find((species) => species.id === selectedPetTypeId);
    const allAvailableSlots =
      slotResponseData?.flatMap((clinic) => clinic?.data ?? []).flatMap((staff) => staff?.data ?? []) ?? [];
    const prepaidSlotsCount = allAvailableSlots.filter(
      (slot) => slot?.prepaid_booking_slot?.toUpperCase() === "YES",
    )?.length;
    const logBody: IClickLogBody = {
      event_type: "SEARCH_SLOT",
      user_id: customerId ? customerId : null,
      client_id: customerId ? customerId : null,
      pet_id: petId ? petId : null,
      pet_type: {
        id: selectedPetTypeId ?? null,
        name: selectedPetType?.title ?? null,
      },
      filter_values: {
        service: {
          id: data?.service ?? null,
          name: selectedServiceName,
        },
        sub_service: {
          id: data?.subService ?? null,
          name: selectedSubServiceName,
        },
        city: data?.city
          ? {
            id: data?.city,
            name: selectedCity?.name ?? null,
          }
          : null,
        clinic: selectedClinics ?? [],
        provider: selectedProviders ?? [],
      },
      number_of_slots: allAvailableSlots?.length,
      prepaid_slots: prepaidSlotsCount,
      location_details: {
        lat: data.lat,
        long: data.long,
      },
      vms_user_id: userLogInfo,
      scr_id: isPageReadonly ? "CHECK_SLOT" : "BOOKING_PAGE",
      timestamp: Date.now(),
    };
    logAPI(logBody);
  };

  const onSubmit = (data: IBookingFiltersFormFields) => {
    dispatch(
      setSelectedSlotDetails({
        data: null,
      }),
    );
    const isFormSubmissionValid = validateConditionalFormFields(data);
    if (!isFormSubmissionValid) {
      setFiltersErrors(true);
      return;
    }
    const wasShown = localStorage.getItem("nudgesShown_bookings");
    const shouldShow = wasShown === null || wasShown === "false";
    if (shouldShow) {
      setHasShownNudges(true);
      localStorage.setItem("nudgesShown_bookings", "true");
    }
    setIsSearchSlotButtonClick(true);
    if (rescheduleBookingId) {
      fetchBookingSummary(rescheduleBookingId);
    }
    if (data && isFormSubmissionValid) {
      const selectedServiceId = subServiceToServiceIdMap[data.subService];
      const constructedFilters: IBookingSlotsFilterBody = {
        user_id: customerId,
        booking_id: rescheduleBookingId ? rescheduleBookingId : null,
        service_type_id: data.service,
        service_id: selectedServiceId ?? data.service,
        sub_service_id: data.subService,
        booking_date: data.date,
        clinic_ids: data.clinics?.filter((id) => id !== "-1"),
        staff_ids: data.providers,
        location_details: {
          latitude: data?.city !== "" ? null : `${data.lat ?? ""}`,
          longitude: data?.city !== "" ? null : `${data.long ?? ""}`,
        },
        city_id: data?.clinics?.length > 0 ? null : getCityIdsForPayload(data.city),
        pet_species_id: isPageReadonly ? data.petSpeciesId : petDetails?.pet_species_type_id,
        slot_status: stringConstants?.slotStatusAvailable,
        ...(data.service === HOME_SERVICE_ID && !rescheduleBookingId && atHomePreviousFlow
          ? { previous_flow: true }
          : {}),
      };
      const shouldSendAhsBookingLink =
        isAhsRepeatUser && data.service === HOME_SERVICE_ID && !isPageReadonly && !rescheduleFlag;
      // Front desk view fetches doctor ROTA itself, no slots needed
      if (!isFrontDeskOverbooking && !shouldSendAhsBookingLink) {
        fetchBookingsSlotsAPI(constructedFilters).then((res) => {
          if (res.status === true) {
            slotSearchClickLog(data, res.message);
          }
        });
        fetchBookedSlotsAPI({ ...constructedFilters, slot_status: "1" });
      }
      dispatch(
        setSlotBookingFilters({
          filters: { ...constructedFilters, city_id: getCityIdsForPayload(data.city) },
        }),
      );
      dispatch(
        setUserAddress({
          address: data?.address_data,
        }),
      );
    }
  };

  const serviceWatch = formHook?.watch("service");
  const allServiceTypeItems = useSelectMenuReducer(serviceTypes, "name", "id");
  const bookingServiceMaps = useMemo(() => buildBookingServiceMaps(serviceTypes ?? []), [serviceTypes]);
  const {
    serviceIdToServiceTypeIdMap,
    subServiceToServiceIdMap,
    serviceTypeToServiceIdsMap,
    subServicesByServiceTypeIdMap,
    serviceTypeNamesByIdMap,
    subServiceByIdMap,
  } = bookingServiceMaps;
  // The backend rejects a non-VC booking being rescheduled onto VC, so don't offer it.
  const blockVcReschedule =
    Boolean(rescheduleFlag) &&
    Boolean(rescheduledBooking?.service_id) &&
    !VC_SERVICE_TYPE_IDS.includes(serviceIdToServiceTypeIdMap[rescheduledBooking?.service_id ?? ""]);
  const serviceTypeItems = blockVcReschedule
    ? allServiceTypeItems.filter((item) => !VC_SERVICE_TYPE_IDS.includes(item.id))
    : allServiceTypeItems;
  const subServices = subServicesByServiceTypeIdMap[serviceWatch] ?? [];
  const watchedServiceId = formHook.watch("service");
  const watchedSubServiceId = formHook.watch("subService");
  const selectedServiceIdForFilters = subServiceToServiceIdMap[watchedSubServiceId] ?? watchedServiceId;
  const selectedServiceTypeIdForFilters =
    serviceIdToServiceTypeIdMap[selectedServiceIdForFilters] ?? watchedServiceId;
  const isHomeServiceFlow = selectedServiceTypeIdForFilters === HOME_SERVICE_ID;
  const selectedQuickServiceIds = watchedSubServiceId
    ? [subServiceToServiceIdMap[watchedSubServiceId]].filter(Boolean)
    : serviceTypeToServiceIdsMap[watchedServiceId] ?? [];
  // Front desk: every booking is an overbooking, so no slot search
  const isFrontDeskOverbooking = useFeatureAccess("FRONT_DESK_OVERBOOKING") && !isPageReadonly;
  const canSendAhsBookingLink = useFeatureAccess("AHS_BOOKING_LINK");

  useEffect(() => {
    const ahsSubServiceId = isHomeServiceFlow && watchedSubServiceId ? watchedSubServiceId : null;
    dispatch(setAhsSubServiceId(ahsSubServiceId));
    dispatch(
      setAhsSubServiceName(ahsSubServiceId ? subServiceByIdMap[ahsSubServiceId]?.sub_service_name ?? null : null),
    );
  }, [isHomeServiceFlow, watchedSubServiceId, subServiceByIdMap, dispatch]);
  const isReadonlyHomeServiceFlow = isPageReadonly && isHomeServiceFlow;
  const isAtHomeReschedule = Boolean(rescheduleFlag) && isHomeServiceFlow;
  let l2ServiceItems: ISelectMenuItemData[] = [];
  const providerItems = useSelectMenuReducer(providers, "name", "staff_id");
  const selectedServiceNames = formHook.watch("serviceName");
  const showBDTemplateButton = selectedServiceNames?.toLowerCase() === "video consultation";
  const latestBookingTitle =
    latestBooking?.sub_service?.name ||
    latestBooking?.service?.name ||
    latestBooking?.subservice_details?.name ||
    latestBooking?.service_details?.name;
  // Front desk overbooking users don't get the last booking auto-fill chip
  const shouldShowLatestBookingChip = Boolean(latestBookingTitle) && !isFrontDeskOverbooking;
  const latestBookingClinicAndCity = [latestBooking?.clinic?.name, latestBooking?.city?.name]
    .filter(Boolean)
    .join(", ");

  useEffect(() => {
    if (!isHomeServiceFlow || isAtHomeReschedule) {
      dispatch(setAtHomePreviousFlow(false));
    }
  }, [isHomeServiceFlow, isAtHomeReschedule, dispatch]);

  // Update Redux with current form service selection for real-time permission checks
  useEffect(() => {
    if (!watchedServiceId) {
      dispatch(setCurrentFormServiceId(null));
      return;
    }
    const resolvedServiceId = subServiceToServiceIdMap[watchedSubServiceId] ?? watchedServiceId;
    dispatch(setCurrentFormServiceId(resolvedServiceId));
  }, [watchedServiceId, watchedSubServiceId, subServiceToServiceIdMap, dispatch]);

  const getSelectedServiceIds = (formFields: IBookingFiltersFormFields): string[] => {
    return resolveBookingServiceSelection({
      maps: bookingServiceMaps,
      selectedServiceKey: formFields?.service,
      selectedSubServiceId: formFields?.subService,
    }).selectedServiceIds;
  };

  const cityByNormalizedName = useMemo(() => buildCityByNormalizedName(cities), [cities]);

  const getCityIdsForPayload = (selectedCityId: string): string[] | null =>
    resolveCityIdsForPayload(selectedCityId, cities, cityByNormalizedName);

  const isAddressOnlyServiceSelected = isHomeServiceFlow;
  const shouldHideCityClinicProvider = isAddressOnlyServiceSelected;

  const subServiceReducer = useSelectMenuReducer;
  if (serviceWatch !== "") {
    if (subServices) {
      l2ServiceItems = subServiceReducer(subServices, "sub_service_name", "sub_service_id");
    } else {
      l2ServiceItems = [];
    }
  }

  const cityItems = useSelectMenuReducer(cities, "name", "id", {
    withAllSelectOption: false,
    allSelectItemOptions: {
      title: "All Cities",
    },
  });

  const clinicItems = useSelectMenuReducer<IClinicListResponseData>(clinics, "display_name", "id", {
    withAllSelectOption: false,
    allSelectItemOptions: {
      title: "All Clinics",
    },
  });

  const applyLastBookingFilters = async () => {
    if (!latestBooking || disableSlotsFilter || isAtHomeReschedule) return;
    logAPI({
      event_type: "PREVIOUS_BOOKING_CLICK",
      scr_id: "BOOKING_PAGE",
      client_id: customerId ? customerId : null,
      pet_id: petId ? petId : null,
      vms_user_id: userLogInfo,
      cta_text: latestBookingTitle,
      clinic_id: latestBooking?.clinic?.id || latestBooking?.clinic_id,
      clinic_name: latestBooking?.clinic?.name,
      filter_values: {
        service_name: latestBookingTitle || null,
        clinic_and_city: latestBookingClinicAndCity || null,
      },
      timestamp: Date.now(),
    });
    const lastServiceId =
      latestBooking?.service?.id || latestBooking?.service_id || latestBooking?.service_details?.id || "";
    const lastSubServiceId =
      latestBooking?.sub_service?.id ||
      latestBooking?.subservice_id ||
      latestBooking?.sub_service_id ||
      latestBooking?.subservice_details?.id ||
      "";
    // A new booking from a legacy diagnostic appointment books its Diagnostics replacement; a reschedule keeps it.
    const { serviceId: latestServiceId, subServiceId: latestSubServiceId } = rescheduleFlag
      ? { serviceId: lastServiceId, subServiceId: lastSubServiceId }
      : toDiagnosticsReplacement(lastServiceId, lastSubServiceId);
    const resolvedServiceId = (latestSubServiceId && subServiceToServiceIdMap[latestSubServiceId]) || latestServiceId;
    const mappedServiceTypeId =
      serviceIdToServiceTypeIdMap[resolvedServiceId] ||
      latestBooking?.service_type?.id ||
      latestBooking?.service_type_id ||
      latestBooking?.service_details?.service_type_id ||
      "";
    const latestCityId =
      latestBooking?.city?.id || latestBooking?.city_id || latestBooking?.clinic_details?.city_id || "";
    const latestClinicId =
      latestBooking?.clinic?.id || latestBooking?.clinic_id || latestBooking?.clinic_details?.id || "";
    const latestProviderId = latestBooking?.staff?.id || "";
    if (mappedServiceTypeId) {
      formHook.setValue("service", mappedServiceTypeId);
      formHook.setValue(
        "serviceName",
        serviceTypeNamesByIdMap[mappedServiceTypeId] ||
        latestBooking?.service_type?.name ||
        latestBooking?.service_details?.name ||
        "",
      );
      formHook.clearErrors("service");
    }
    if (latestSubServiceId) {
      formHook.setValue("subService", latestSubServiceId);
      formHook.setValue(
        "subServiceName",
        subServiceByIdMap[latestSubServiceId]?.sub_service_name ||
        latestBooking?.sub_service?.name ||
        latestBooking?.subservice_details?.name ||
        "",
      );
      formHook.clearErrors("subService");
    }
    formHook.setValue("address", null);
    formHook.setValue("address_data", null);
    formHook.setValue("locationId", null);
    formHook.setValue("lat", null);
    formHook.setValue("long", null);
    if (latestCityId) {
      await fetchPWLClinics({
        cityIds: [latestCityId],
        withProviders: false,
        ROTADate: formHook.getValues("date"),
      });
      formHook.setValue("city", latestCityId);
      formHook.clearErrors("city");
    }
    if (latestClinicId) {
      setSelectedClinic([latestClinicId]);
      formHook.setValue("clinics", [latestClinicId]);
      formHook.clearErrors("clinics");
    } else {
      setSelectedClinic(null);
      formHook.setValue("clinics", []);
    }
    pendingLatestProviderIdRef.current = latestProviderId || null;
    formHook.setValue("providers", []);
    onSubmit(formHook.getValues());
  };

  useEffect(() => {
    if (shouldHideCityClinicProvider) return;
    const formFields: IBookingFiltersFormFields = formHook.getValues();
    if (formFields && userRole && formFields.city !== "") {
      const selectedCityIds = getCityIdsForPayload(formFields.city) ?? [];
      fetchPWLClinics({
        cityIds: selectedCityIds,
        withProviders: false,
        ROTADate: formFields?.date,
      }).then(() => {
        formHook.setValue("city", formFields.city);
        if (selectedClinic) {
          formHook.setValue("clinics", selectedClinic);
        } else if (isSelectedCityIncludedInFilter(formHook.getValues("city"), slotsFilters?.city_id)) {
          formHook.setValue("clinics", slotsFilters?.clinic_ids);
        } else {
          formHook.setValue("clinics", []);
        }
      });
    }
  }, [formHook.watch("city"), shouldHideCityClinicProvider]);

  useEffect(() => {
    if (formHook.getValues("service")) {
      if (l2ServiceItems?.length === 1) {
        formHook.setValue("subService", l2ServiceItems[0]?.id);
        formHook.setValue("subServiceName", l2ServiceItems[0]?.title);
      }
    }
  }, [formHook.watch("service")]);

  useEffect(() => {
    if (shouldHideCityClinicProvider) return;
    const formFields: IBookingFiltersFormFields = formHook.getValues();
    if (isHomeServiceFlow) {
      formHook.setValue("providers", []);
      return;
    }
    if (formFields && userRole) {
      const selectedServiceIds = getSelectedServiceIds(formFields);
      const selectedCityIds = getCityIdsForPayload(formFields.city) ?? [];
      if (formFields.clinics.includes("-1")) {
        fetchPWLProviders({
          ROTADate: formFields?.date,
          clinicIds: clinics.map((c) => c.id),
          serviceId: selectedServiceIds,
          cityId: selectedCityIds,
          user_id: customerId,
        });
      } else {
        fetchPWLProviders({
          ROTADate: formFields?.date,
          clinicIds: [...formFields.clinics],
          serviceId: selectedServiceIds,
          cityId: selectedCityIds,
          user_id: customerId,
        });
      }
      formHook.setValue("providers", []);
    }
  }, [
    formHook.watch("clinics"),
    formHook.watch("service"),
    formHook.watch("subService"),
    shouldHideCityClinicProvider,
  ]);

  useEffect(() => {
    if (!shouldHideCityClinicProvider) return;
    formHook.setValue("city", "");
    formHook.setValue("clinics", []);
    formHook.setValue("providers", []);
  }, [shouldHideCityClinicProvider]);

  useEffect(() => {
    const locationId = formHook.getValues("locationId");
    const selectedCity = formHook.getValues("city");
    if (locationId === "" || locationId === null || locationId === undefined) return;
    if (selectedCity) return;
    if (locationId !== null && locationId !== "") {
      formHook.setValue("city", "");
      formHook.setValue("clinics", []);
      formHook.setValue("providers", []);
    }
  }, [formHook.watch("locationId")]);

  useEffect(() => {
    if (Object?.keys(slotsFilters ?? {})?.length > 0 && serviceTypes?.length > 0) {
      const visibleCityId = getVisibleCityIdFromFilter(slotsFilters?.city_id);
      if (visibleCityId !== "") {
        formHook.setValue("city", visibleCityId);
      }
      // A reschedule keeps the booking's own sub service; a new booking swaps a delisted legacy diagnostic one.
      const subServiceId = rescheduleFlag
        ? slotsFilters?.sub_service_id
        : resolveLegacyDiagnosticSubServiceId(slotsFilters?.sub_service_id, (id) => !!subServiceToServiceIdMap[id]);
      const isReplacedSubService = subServiceId !== slotsFilters?.sub_service_id;
      const mappedTypeId =
        (!isReplacedSubService && serviceIdToServiceTypeIdMap[slotsFilters?.service_id]) ||
        serviceIdToServiceTypeIdMap[subServiceToServiceIdMap[subServiceId]];
      if (mappedTypeId) {
        formHook.setValue("service", mappedTypeId);
      }
      // Only rehydrate, never overwrite a sub service the user has already picked
      if (!formHook.getValues("subService")) {
        formHook.setValue("subService", subServiceId);
      }
      formHook.setValue("date", slotsFilters?.booking_date);
      formHook.setValue("long", slotsFilters?.location_details?.longitude);
      formHook.setValue("lat", slotsFilters?.location_details?.latitude);
    }
  }, [slotsFilters, serviceTypes]);

  useEffect(() => {
    if (defaultServiceAppliedRef.current || !serviceTypes?.length) return;
    defaultServiceAppliedRef.current = true;
    if (isPageReadonly || rescheduleFlag || Object.keys(slotsFilters ?? {}).length > 0) return;
    if (formHook.getValues("service") || formHook.getValues("subService")) return;
    const opdService = serviceList.find((item) => item.label === "OPD");
    if (opdService) setSelecteSubService(opdService.service_id, opdService.subservice_id);
  }, [serviceTypes]);

  useEffect(() => {
    fetchOverbookingList();
    fetchOrgServicesByFilter({ filterType: "booking_vms" });
    fetchOrgCities({
      withClinics: false,
      ROTADate: formHook.watch("date"),
      withClinicProviders: false,
      clinicOptions: {
        selectFirst: false,
      },
    });
  }, []);

  useEffect(() => {
    if (!customerId || isPageReadonly || !canSendAhsBookingLink) return;
    fetchPersonaDetails(customerId);
  }, [customerId, isPageReadonly, canSendAhsBookingLink, fetchPersonaDetails]);

  useEffect(() => {
    const normalizedTags = personaTags.map((tag) => tag.trim().toLowerCase());
    const hasEligibleCity = AHS_BOOKING_LINK_ELIGIBLE_CITIES.some((city) =>
      normalizedTags.includes(city.trim().toLowerCase()),
    );
    dispatch(setIsAhsRepeatUser(canSendAhsBookingLink && normalizedTags.includes(AHS_REPEAT_PERSONA) && hasEligibleCity));
  }, [personaTags, canSendAhsBookingLink, dispatch]);

  useEffect(() => {
    if (!customerId || !petId) return;
    const fetchKey = `${customerId}-${petId}`;
    if (latestBookingFetchKeyRef.current === fetchKey) return;
    latestBookingFetchKeyRef.current = fetchKey;
    fetchLatestBooking(customerId, petId);
  }, [customerId, petId, fetchLatestBooking]);

  useEffect(() => {
    setSlotsAddressList(customerAddresses ?? []);
  }, [customerAddresses]);

  // Reschedule: fetch the previous booking's clinic details so we can resolve its city
  useEffect(() => {
    if (!rescheduleBookingId) return;
    const clinicId = rescheduledBooking?.clinic_id;
    if (!clinicId) return;
    fetchRescheduleClinicDetails(clinicId);
  }, [rescheduleBookingId, rescheduledBooking?.clinic_id, fetchRescheduleClinicDetails]);

  // Reschedule: prefill city + clinic from the previous booking (only service prefilled otherwise)
  useEffect(() => {
    if (!rescheduleBookingId) return;
    if (shouldHideCityClinicProvider) return;
    const clinicId = rescheduledBooking?.clinic_id;
    if (!clinicId || !rescheduleClinicDetails || !cities?.length) return;
    if (rescheduleClinicPrefilledRef.current === rescheduleBookingId) return;
    const resolvedCityId =
      cityByNormalizedName.get(normalizeCityName(rescheduleClinicDetails?.city_name))?.id ?? "";
    if (!resolvedCityId) return;
    rescheduleClinicPrefilledRef.current = rescheduleBookingId;
    setSelectedClinic([clinicId]);
    formHook.setValue("city", resolvedCityId);
    formHook.clearErrors("city");
    formHook.clearErrors("clinics");
  }, [
    rescheduleBookingId,
    rescheduledBooking?.clinic_id,
    rescheduleClinicDetails,
    cities,
    cityByNormalizedName,
    shouldHideCityClinicProvider,
  ]);

  // Reschedule: auto-run the slot search once service/date/city/clinic are prefilled
  useEffect(() => {
    if (!rescheduleBookingId) return;
    if (shouldHideCityClinicProvider) return;
    if (rescheduleAutoSearchedRef.current === rescheduleBookingId) return;
    const clinicId = rescheduledBooking?.clinic_id;
    if (!clinicId) return;
    const values = formHook.getValues();
    if (!values.service || !values.date || !values.city) return;
    if (!values.clinics?.includes(clinicId)) return;
    // Ensure the clinic list for the resolved city has loaded before searching
    if (!clinics?.some((clinic) => clinic.id === clinicId)) return;
    rescheduleAutoSearchedRef.current = rescheduleBookingId;
    onSubmit(values);
  }, [
    rescheduleBookingId,
    shouldHideCityClinicProvider,
    rescheduledBooking?.clinic_id,
    clinics,
    formHook.watch("service"),
    formHook.watch("city"),
    formHook.watch("clinics"),
    formHook.watch("date"),
  ]);

  useEffect(() => {
    if (!isHomeServiceFlow) return;
    if (!reduxUserAddress) return;
    const currentAddressId = formHook.getValues("locationId");
    const nextAddressId = (reduxUserAddress as any)?.address_id ?? (reduxUserAddress as any)?.id ?? null;
    if (currentAddressId && currentAddressId === nextAddressId) return;
    const formattedAddress =
      (reduxUserAddress as any)?.state?.formattedAddress || (reduxUserAddress as any)?.title || "";
    formHook.setValue("address_data", reduxUserAddress);
    formHook.setValue("address", formattedAddress);
    formHook.setValue("locationId", nextAddressId);
    formHook.setValue("lat", (reduxUserAddress as any)?.state?.lat ?? null);
    formHook.setValue("long", (reduxUserAddress as any)?.state?.long ?? null);
  }, [reduxUserAddress, isHomeServiceFlow]);

  const homeServiceFetchKey =
    isHomeServiceFlow && !isPageReadonly && watchedSubServiceId && formHook.watch("locationId")
      ? `${watchedSubServiceId}|${formHook.watch("date")}|${formHook.watch("locationId")}`
      : null;
  useEffect(() => {
    if (homeServiceFetchKey) onSubmit(formHook.getValues());
  }, [homeServiceFetchKey]);

  const handleAddressSelectionForHomeService = async (address: ISlotsAddressOption) => {
    const transformedAddress = mapAddressToGeoOption(address);
    const updatedFormValues = {
      ...formHook.getValues(),
      address: address?.address_2 ?? "",
      address_data: transformedAddress,
      locationId: address?.address_id ?? null,
      lat: address?.latitude ?? null,
      long: address?.longitude ?? null,
      city: "",
      clinics: [],
      providers: [],
    } as IBookingFiltersFormFields;
    formHook.setValue("address", updatedFormValues.address);
    formHook.setValue("address_data", updatedFormValues.address_data);
    formHook.setValue("locationId", updatedFormValues.locationId);
    formHook.setValue("lat", updatedFormValues.lat);
    formHook.setValue("long", updatedFormValues.long);
    formHook.setValue("city", "");
    formHook.setValue("clinics", []);
    formHook.setValue("providers", []);
    dispatch(
      setUserAddress({
        address: transformedAddress,
      }),
    );
    setIsAddressListModalOpen(false);
  };

  const handelSelectClinic = (clinicDetails: IGeoClinicDetails) => {
    formHook.setValue("address", null);
    formHook.setValue("lat", null);
    formHook.setValue("long", null);
    formHook.setValue("locationId", null);
    formHook.setValue("city", clinicDetails?.city_id);
    setSelectedClinic([clinicDetails?.clinic_id]);
    const selectedCityIds = getCityIdsForPayload(clinicDetails?.city_id) ?? [];
    fetchPWLClinics({
      cityIds: selectedCityIds,
      withProviders: false,
      ROTADate: formHook.getValues("date"),
    }).then(() => {
      formHook.setValue("city", clinicDetails?.city_id);
      formHook.setValue("clinics", [clinicDetails?.clinic_id]);
    });
  };

  const setSelectedDate = (date: string) => {
    formHook.setValue("date", date);
    // At-home and front desk views read the date from filters, so update it without a new search
    if (!isHomeServiceFlow && !isFrontDeskOverbooking) return;
    if (!slotsFilters) return;
    dispatch(
      setSlotBookingFilters({
        filters: {
          ...slotsFilters,
          booking_date: date,
        },
      }),
    );
  };

  const setSelecteSubService = (service_id: string, subservice_id: string) => {
    const resolvedServiceId = subServiceToServiceIdMap[subservice_id] || service_id;
    const mappedServiceTypeId = serviceIdToServiceTypeIdMap[resolvedServiceId];
    if (mappedServiceTypeId) {
      formHook.setValue("service", mappedServiceTypeId);
      formHook.setValue("serviceName", serviceTypeNamesByIdMap[mappedServiceTypeId] ?? "");
    }
    const resolvedSubServiceId =
      subservice_id ||
      (isPageReadonly && mappedServiceTypeId
        ? subServicesByServiceTypeIdMap[mappedServiceTypeId]?.find(
            (subService) => subServiceToServiceIdMap[subService.sub_service_id] === resolvedServiceId,
          )?.sub_service_id ?? ""
        : "");
    formHook.setValue("subService", resolvedSubServiceId);
    formHook.setValue("subServiceName", subServiceByIdMap[resolvedSubServiceId]?.sub_service_name ?? "");
    formHook.clearErrors("service");
    formHook.clearErrors("subService");
  };

  const selectedAddressData = formHook.watch("address_data") as any;
  const selectedAddressText =
    selectedAddressData?.state?.formattedAddress || selectedAddressData?.title || formHook.watch("address") || "";

  const handleBDTemplateClick = () => {
    if (!customerId) {
      toast.error("User information not found");
      return;
    }
    const logBody: IClickLogBody = {
      event_type: "SEND_VC_LINK_BUTTON_CLICK",
      client_id: customerId ? customerId : null,
      pet_id: petId ? petId : null,
      vms_user_id: userLogInfo,
      scr_id: isPageReadonly ? "CHECK_SLOT" : "BOOKING_PAGE",
      timestamp: Date.now(),
    };
    logAPI(logBody);
    setOpenVCLink(true);
  };

  const handleCheckPriceClick = () => {
    const logBody: IClickLogBody = {
      event_type: "CHECK_PRICE_BUTTON_CLICK",
      client_id: customerId ? customerId : null,
      pet_id: petId ? petId : null,
      vms_user_id: userLogInfo,
      scr_id: isPageReadonly ? "CHECK_SLOT" : "BOOKING_PAGE",
      timestamp: Date.now(),
    };
    logAPI(logBody);
    setIsCheckPricesOpen(true);
  };

  const handleNearbyLocationSelect = (item: any) => {
    if (!isHomeServiceFlow) {
      formHook.setValue("address_data", item);
    }
    formHook.setValue("locationId", item.id);
    formHook.setValue("lat", item.state.lat);
    formHook.setValue("long", item.state.long);
    // Address search overrides any city/clinic filter — clear them so the
    // results (and distances) reflect the searched location, not the filter.
    setSelectedClinic(null);
    formHook.setValue("city", "");
    formHook.setValue("clinics", []);
    formHook.setValue("providers", []);
    formHook.clearErrors("city");
    formHook.clearErrors("clinics");
    const logBody: IClickLogBody = {
      event_type: "SEARCH_NEAREST_CLINIC_BY_ROTA",
      client_id: customerId ? customerId : null,
      pet_id: petId ? petId : null,
      location_details: {
        lat: item.state.lat,
        long: item.state.long,
        address: item?.title,
      },
      vms_user_id: userLogInfo,
      scr_id: isPageReadonly ? "CHECK_SLOT" : "BOOKING_PAGE",
      timestamp: Date.now(),
    };
    item?.title && logAPI(logBody);
  };

  const handleNearbyLocationClear = () => {
    formHook.setValue("locationId", null);
    formHook.setValue("lat", null);
    formHook.setValue("long", null);
  };

  return {
    formHook,
    // page-level flags shared across sections
    page: {
      isPageReadonly,
      disableSlotsFilter,
      showFilters,
      isHomeServiceFlow,
      isReadonlyHomeServiceFlow,
      isAtHomeReschedule,
    },
    // customer/pet context
    customer: { customerId, petId, petDetails },
    // "Last booking" quick-apply chip in the header
    lastBookingChip: {
      shouldShowLatestBookingChip,
      latestBooking,
      isLatestBookingInProgress,
      latestBookingTitle,
      latestBookingClinicAndCity,
      applyLastBookingFilters,
    },
    // Check-price modal in the header
    checkPrice: {
      isCheckPricesOpen,
      setIsCheckPricesOpen,
      handleCheckPriceClick,
    },
    // Filter dropdowns (service / sub-service / city / clinics / providers)
    filterFields: {
      petSpeciesItems,
      serviceTypeItems,
      l2ServiceItems,
      cityItems,
      clinicItems,
      providerItems,
      selectedQuickServiceIds,
      setSelectedClinic,
    },
    // Home-service address block + its modals
    homeAddress: {
      selectedAddressText,
      isAddressListModalOpen,
      setIsAddressListModalOpen,
      isAddAddressModalOpen,
      setIsAddAddressModalOpen,
      selectedAddressId,
      setSelectedAddressId,
      slotsAddressList,
      setSlotsAddressList,
      handleAddressSelectionForHomeService,
    },
    // Nearby-location geo search
    nearbyLocation: {
      handleNearbyLocationSelect,
      handleNearbyLocationClear,
    },
    // Send-VC-link button + modal
    vcLink: {
      showBDTemplateButton,
      openVCLink,
      setOpenVCLink,
      handleBDTemplateClick,
      rescheduleBookingId: rescheduleFlag ? rescheduledBooking?.booking_id : undefined,
    },
    // Inline banners / notices in the form
    banners: {
      isPaidbooking,
      isPaidPriceAmount,
      isSearchSlotButtonClick,
      hasShownNudges,
      filtersError,
      subServiceToServiceIdMap,
    },
    // Shared handlers used directly by the orchestrator
    isFrontDeskOverbooking,
    handelSelectClinic,
    onSubmit,
    setSelectedDate,
    setSelecteSubService,
  };
};
